/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { CompanyLogoOutlined, ArrowRightShape } from "@themuse/design-system";
import cn from "classnames";

import { IndustryIcon } from "components/icons/IndustryIcon";
import { SizeIcon } from "components/icons/SizeIcon";
import { SingleCompany } from "interfaces/api/apiInterfaces";
import { formatCompanySize, getCompanyIndustries, getCompanyLogo } from "utils/strings";

import styles from "./CompanyInformationModule.module.scss";


const getPilboxUrl = (imageUrl: string, imageWidth: number): string => {
    const pilboxUrl = "https://pilbox.themuse.com/";
    const imageUrlRegex = /^https?:\/\//;

    if (imageUrlRegex.test(imageUrl)) {
        return `${pilboxUrl}?url=${imageUrl}&w=${imageWidth}&filter=antialias&opt=1&pos=center&prog=1&q=keep`;
    }

    return "";
};

interface ICompanyInformationModule {
    company: SingleCompany;
    displayOnMobile?: boolean;
}
export const CompanyInformation = (props: ICompanyInformationModule) => {
    const { company, displayOnMobile = false } = props;
    const companySize = formatCompanySize(company?.employee_range);
    const companyIndustries = getCompanyIndustries(company?.industries);
    const companyLogo = getCompanyLogo(company?.logo) || "";
    const snapshotPhotoSrc = getPilboxUrl(company?.snapshot_photo, 500);
    const display = displayOnMobile ? "mobile" : "desktop";
    const containerClasses = cn(
        snapshotPhotoSrc
            ? `${styles.companyInformationModule} ${styles.hasPhoto} ${styles[display]}`
            : `${styles.companyInformationModule} ${styles[display]}`
    );

    return (
        <aside className={containerClasses}>
            {companyLogo
                ? (
                    <CompanyLogoOutlined
                        className={styles.companyLogo}
                        logoUrl={companyLogo}
                        altText={`${company?.name} Logo`}
                    />
                )
                : null}

            {company?.short_description?.length > 10
                ? (
                    <>
                        <h2>About Us</h2>
                        <p className={styles.companyShortDescription}>{company.short_description}</p>
                    </>
                )
                : null}

            <ul>
                {company?.employee_range
                    ? (<li><SizeIcon /><strong>Size:</strong> {`${companySize} employees`}</li>)
                    : null}
                {company?.industries?.length
                    ? (<li><IndustryIcon /><strong>Industry:</strong> {companyIndustries}</li>)
                    : null
                }
            </ul>

            {snapshotPhotoSrc
                ? (
                    <img
                        alt={company?.name}
                        loading={displayOnMobile ? "lazy" : "eager"}
                        src={snapshotPhotoSrc}
                        height="167"
                        width="250" />
                )
                : null}

            <a className={styles.companyProfileLink} href={`/profiles/${company?.short_name}`} target="_blank">
                View Company Profile<ArrowRightShape />
            </a>
        </aside>
    );
};

CompanyInformation.displayName = "CompanyInformationModule";

export const CompanyInformationModule = React.memo(CompanyInformation);
